(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6172],{

/***/ 43818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.c = function IoCheckmarkCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"}}]})(props);
};


/***/ }),

/***/ 5885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FarmCategoryListGrouped; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52494);
/* harmony import */ var _react_icons_all_files_io5_IoCheckmarkCircle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43818);



var FarmCategoryListGrouped = function(param) {
    var categories = param.categories, categoryIds = param.categoryIds;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Wrap */ .Eq, {
        direction: {
            base: "column",
            md: "row"
        },
        spacing: 4,
        children: categories.map(function(categoryParagraph, i) {
            if (!categoryParagraph.category.showOnFarm) return null;
            if (categoryIds && !categoryIds.includes(categoryParagraph.category.id)) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .WrapItem */ .Uc, {
                flexDirection: "column",
                color: "primary",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        fontWeight: "bold",
                        children: categoryParagraph.category.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        ml: 4,
                        mt: 2,
                        children: categoryParagraph.subCategories.map(function(subCategory, j) {
                            if (!subCategory.showOnFarm) return null;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                            mr: 1,
                                            fontSize: "xl",
                                            as: _react_icons_all_files_io5_IoCheckmarkCircle__WEBPACK_IMPORTED_MODULE_3__/* .IoCheckmarkCircle */ .c,
                                            color: "primary"
                                        }),
                                        subCategory.title
                                    ]
                                })
                            }, j);
                        })
                    })
                ]
            }, i);
        })
    });
};


/***/ }),

/***/ 46172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FarmFarmCategories": function() { return /* reexport */ FarmFarmCategories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/FarmContext.ts
var FarmContext = __webpack_require__(66771);
// EXTERNAL MODULE: ./src/components/Node/Farm/FarmCategoryListGrouped.tsx
var FarmCategoryListGrouped = __webpack_require__(5885);
;// CONCATENATED MODULE: ./src/components/Paragraph/FarmFarmCategories/FarmFarmCategories.tsx




var FarmFarmCategories = function(param) {
    var data = param.data;
    var ref, ref1;
    var farmContext = (0,react.useContext)(FarmContext/* FarmContext */.z);
    if (!((ref = farmContext.farm) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCategoryListGrouped/* FarmCategoryListGrouped */.l, {
        categories: farmContext.farm.categories,
        categoryIds: data.categories.map(function(category) {
            return category.id;
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/FarmFarmCategories/index.ts



/***/ }),

/***/ 66771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ FarmContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var FarmContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ })

}]);